<template>
  <div class="user">
    <img src="../assets/user.png" mode="widthFix" class="user_image" />
    <div class="user_foot">
      <div v-html="nodes"></div>
      <!-- <div class="foot_label">用户协议 </div>
      <block v-for="(item,index) in list" :key="index">
        <div class="foot_title">{{item.title}}</div>
        <div class="foot_item">{{item.content}}</div>
      </block> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "User",
  data() {
    return {
      nodes:'',
      list: [
        {title: '1、声明与承诺',content: `用中在法街众餐用公合公服务时，家须南小公内提供资安、准路、武融、合法有效的资料、日有义务维拾并及的更新
相关资料、用户应省保证在嘅号名称、头佛和备介零注册信`},
        {title: '2、用户权利与义务',content: `1、用中在法街众餐用公合公服务时，家须南小公内提供资安、准路、武融、合法有效的资料、日有义务维拾并及的
更新相关资料、用户应省保证在嘅号名称、头佛和备介零注册信`},
      ]
    };
  },
  created(){
    this.getUser();
  },
  methods: {
    // 获取用户协议
    getUser(){
      this.$getRequest("/get_agreement/4").then((res) => {
        this.nodes = res.data.content;
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.user_foot {
  width: 100%;
  min-height: 1091px;
  background: #fffaf4;
  padding: 61px 260px 78px;
  box-sizing: border-box;
  text-align: left;
  .foot_label {
    font-size: 45px;
    color: #447849;
  }
  .foot_title {
    font-size: 30px;
    font-weight: bold;
    margin: 29px 0;
  }
  .foot_item {
    font-size: 25px;
    width: 1400px;
    background: #FFF6EB;
    padding: 33px 18px 33px 57px;
  }
}
.user {
  width: 100%;
}
.user_image {
  width: 100%;
  display: block;
}
</style>
